import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

/**
 * FirstPlayerModal Component
 * Modal for selecting the first player at game start
 *
 * @param {boolean} show - Whether to show the modal
 * @param {Array} players - Array of player objects
 * @param {string} currentPlayerName - Name of the current user
 * @param {function} onSelectPlayer - Callback when a player is selected
 * @param {function} onRandomSelect - Callback for random selection
 * @param {boolean} spinningWheel - Whether the random selection animation is active
 */
const FirstPlayerModal = ({
  show,
  players,
  currentPlayerName,
  onSelectPlayer,
  onRandomSelect,
  spinningWheel
}) => {
  const { t } = useLanguage();

  if (!show) return null;

  return (
    <div className="modal-overlay">
      <div className="player-selection-modal">
        <h2 style={{
          textAlign: 'center',
          marginBottom: '0.5rem',
          background: 'linear-gradient(to right, #ef4444, #f59e0b, #10b981, #3b82f6)',
          WebkitBackgroundClip: 'text',
          backgroundClip: 'text',
          color: 'transparent',
          textShadow: '2px 2px 4px rgba(0, 0, 0, 0.1)',
          fontSize: '2.5rem',
          fontWeight: '700',
          position: 'relative',
          display: 'inline-block',
          padding: '0 1rem',
          letterSpacing: '0.05em'
        }}>{t('firstPlayerSelection.title') || 'Select First Player'}</h2>
        <p>{t('firstPlayerSelection.instruction') || 'Choose who will go first in this game:'}</p>

        <div className="player-list">
          {players && players.map((player, index) => (
            <button
              key={index}
              className="player-select-btn"
              onClick={() => onSelectPlayer(player.name)}
              disabled={spinningWheel}
            >
              {player.name} {player.name === currentPlayerName ? `(${t('common.you') || 'You'})` : ''}
            </button>
          ))}
        </div>

        <button
          className="random-player-btn"
          onClick={onRandomSelect}
          style={{
            marginTop: '1rem',
            padding: '0.75rem 1.5rem',
            borderRadius: '0.5rem',
            backgroundColor: '#8b5cf6',
            color: 'white',
            border: 'none',
            fontWeight: '600',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.5rem',
            margin: '1rem auto',
            boxShadow: '0 4px 6px rgba(139, 92, 246, 0.3)'
          }}
          disabled={spinningWheel}
        >
          <span role="img" aria-label="dice">🎲</span>
          {t('buttons.randomSelection') || 'Random Selection'}
        </button>

        {spinningWheel && (
          <div className="spinner-overlay">
            <div className="loading-spinner"></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FirstPlayerModal;
